import BaseTitleIcon from '@/components/PHR/BaseTitleIcon';
import utils from '@/utils';
import { Form, Input, Button, message, DatePicker, Select } from 'antd';
import * as React from 'react';
import userService from '@/apis/user/service';
import dayjs from 'dayjs';
import suggestService from '@/apis/suggest/service';
import constants from '@/constants';

export interface IInfoDetailProps {
  user: IUser;
  uid: string;
  onClose?: () => void;
}

const InfoDetail: React.FC<IInfoDetailProps> = ({ user, uid, ...props }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { mutate: updateUser, isPending } = userService.useUpdateUser({
    onSuccess: () => {
      messageApi.success('Cập nhật thông tin thành công');
    },
    onError: (error: any) => {
      messageApi.error(error?.response?.data?.error?.message || 'Cập nhật thất bại');
    },
  });

  const { data: doctorData, isLoading: isLoadingDoctors } = suggestService.useSearch({
    key: 'doctor',
    limit: 100,
  });

  const doctorOptions = React.useMemo(() => {
    const options = (doctorData?.data || []).map((d: any) => ({
      label: String(d.text || d.username || d.name),
      value: d.id || d._id,
    }));

    const currentDoctor = user?.family?.doctor as any;
    const currentId = currentDoctor?._id || currentDoctor?.id;

    if (currentId && !options.find((o: any) => o.value === currentId)) {
      options.unshift({
        label: String(currentDoctor.username || 'Bác sĩ hiện tại'),
        value: currentId,
      });
    }

    return options;
  }, [doctorData, user?.family?.doctor]);

  const onFinish = (values: any) => {
    updateUser({
      ...values,
      _id: user._id,
      birthday: values.birthday ? dayjs(values.birthday).toISOString() : undefined,
    });
  };

  React.useEffect(() => {
    const doctor = user?.family?.doctor as any;
    form.setFieldsValue({
      code: user?.code,
      birthday: user?.birthday ? dayjs(user?.birthday) : undefined,
      email: user?.email,
      address: utils.safeAddress(user?.address),
      job: user?.job,
      phone: user?.phone,
      familyCode: user?.family?.code,
      doctor: doctor?._id || doctor?.id || doctor?.username,
    });
  }, [user, form]);

  return (
    <>
      {contextHolder}
      <div className="px-4 w-full max-h-[75vh] overflow-y-auto">
        <Form form={form} layout="vertical" className="pb-4" onFinish={onFinish}>
          <BaseTitleIcon src="/icons/Regular/User - icon.svg" title="Thông tin cá nhân" />

          <Form.Item label="Mã tài khoản" name="code" className="mb-1">
            <Input className="!shadow-none hover:shadow-md focus:!shadow-lg focus:!border-blue-500 transition-all" />
          </Form.Item>

          <Form.Item label="Ngày sinh" name="birthday" className="mb-1">
            <DatePicker className="w-full" format={constants.DATE_FORMAT} />
          </Form.Item>

          <Form.Item label="Email" name="email" className="mb-1">
            <Input className="!shadow-none hover:shadow-md focus:!shadow-lg focus:!border-blue-500 transition-all" />
          </Form.Item>

          {/* <Form.Item label="Địa chỉ" name="address" className="mb-1">
            <Input />
          </Form.Item> */}

          <Form.Item label="Nghề nghiệp" name="job" className="mb-1">
            <Input className="!shadow-none hover:shadow-md focus:!shadow-lg focus:!border-blue-500 transition-all" />
          </Form.Item>

          <Form.Item label="SĐT người liên hệ" name="phone" className="mb-1">
            <Input className="!shadow-none hover:shadow-md focus:!shadow-lg focus:!border-blue-500 transition-all" />
          </Form.Item>

          <BaseTitleIcon src="/icons/Regular/Home - icon.svg" title="Danh sách gia đình" />
          <Form.Item label="Mã gia đình" name="familyCode" className="mb-1">
            <Input className="!shadow-none hover:shadow-md focus:!shadow-lg focus:!border-blue-500 transition-all" />
          </Form.Item>

          <BaseTitleIcon src="/icons/Regular/Doctor - icon.svg" title="Người phụ trách" />
          <Form.Item label="Bác sỹ" name="doctor" className="mb-1">
            <Select
              showSearch
              options={doctorOptions}
              loading={isLoadingDoctors}
              placeholder="Chọn bác sỹ"
              filterOption={(input, option) =>
                String(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <div className="flex justify-end mt-4">
            <Button type="primary" htmlType="submit" className="bg-blue-6" loading={isPending}>
              Cập nhật
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};
export default InfoDetail;